import { render } from "./Information.vue?vue&type=template&id=5be6145a&scoped=true&ts=true"
import script from "./Information.vue?vue&type=script&lang=ts"
export * from "./Information.vue?vue&type=script&lang=ts"

import "./Information.vue?vue&type=style&index=0&id=5be6145a&lang=scss&scoped=true"
import "./Information.vue?vue&type=style&index=1&id=5be6145a&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be6145a"]])

export default __exports__